module.exports = __webpack_public_path__ + "static/Group 1163-30deb72934a2e8a14d23ce1e082ee649.png";